import React from 'react';
import { useMultiReports } from '../MultiReportsContext';

export function BulkEditModal() {
  const { 
    showBulkEditModal,
    setShowBulkEditModal,
    selectedBookings,
    activeFieldTab,
    activeTab,
    activeFields,
    bulkEditData,
    setBulkEditData,
    handleBulkEdit
  } = useMultiReports();

  if (!showBulkEditModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow-2xl max-h-[90vh] overflow-y-auto">
        <h3 className="text-lg font-bold mb-2 text-gray-800">Bulk Edit - {activeTab?.label}</h3>
        <p className="text-sm text-gray-600 mb-4">
          Updating {selectedBookings.length} selected booking(s). Leave fields empty to skip.
        </p>
        
        {/* Special note for Discounts tab */}
        {activeFieldTab === 'discounts' && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
            <p className="text-sm text-yellow-800 font-medium">💡 Bulk Discount Update</p>
            <p className="text-xs text-yellow-700 mt-1">
              Enter values to update all selected bookings at once. Use this for applying scheme discounts or pool amounts in bulk.
            </p>
          </div>
        )}
        
        <div className="space-y-4">
          {activeFields.map(field => (
            <div key={field.id}>
              <label className="block text-sm font-medium text-gray-700 mb-1">{field.label}</label>
              {field.type === 'select' ? (
                <select
                  value={bulkEditData[field.id] || ''}
                  onChange={(e) => setBulkEditData(prev => ({ ...prev, [field.id]: e.target.value }))}
                  className="w-full p-2 border rounded-lg"
                >
                  <option value="">-- No Change --</option>
                  {field.options.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              ) : field.type === 'date' ? (
                <input
                  type="date"
                  value={bulkEditData[field.id] || ''}
                  onChange={(e) => setBulkEditData(prev => ({ ...prev, [field.id]: e.target.value }))}
                  className="w-full p-2 border rounded-lg"
                />
              ) : (
                <input
                  type={field.type === 'number' ? 'number' : 'text'}
                  value={bulkEditData[field.id] || ''}
                  onChange={(e) => setBulkEditData(prev => ({ ...prev, [field.id]: e.target.value }))}
                  className="w-full p-2 border rounded-lg"
                  placeholder={field.type === 'number' ? `Enter amount in ₹` : `Enter ${field.label.toLowerCase()}`}
                />
              )}
            </div>
          ))}
        </div>

        <div className="flex gap-2 mt-6">
          <button
            onClick={handleBulkEdit}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
            data-testid="confirm-bulk-edit"
          >
            Update All ({selectedBookings.length})
          </button>
          <button
            onClick={() => { setShowBulkEditModal(false); setBulkEditData({}); }}
            className="flex-1 px-4 py-2 border rounded-lg hover:bg-gray-100 font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
